import React from "react";
import { EvtHeader } from "components/header";
import EditItemButton from "components/buttons/edit";
import HeaderPortal from "components/portal/header-portal";
import { PermissionControlledInput } from "permissions/components/input";
import { ContractDashboardStatsSection } from "./components/dashboard-stats-section";

const ContractDashboard = () => {
  return (
    <div className="flex-1 overflow-auto pb-5">
      <EvtHeader title="Dashboard" />

      <ContractDashboardStatsSection />

      <HeaderPortal>
        <PermissionControlledInput
          rule="update:*"
          collection="contracts"
        >
          <EditItemButton />
        </PermissionControlledInput>
      </HeaderPortal>
    </div>
  );
};

export default ContractDashboard;


